import firedux from '../firedux'
import {dispatch, getState} from '../store'

import {
  STRIPE_CUSTOMERS_ENDPOINT
} from '../../config/constants'

import setCurrentCustomer from '../actions/set_current_customer'

const onCurrentCustomer = (snapshot) => {
  if (snapshot.exists()) dispatch(setCurrentCustomer(snapshot.val()))
}

export const watchCurrentCustomer = (uid) => {
  if (!uid) return

  const ENDPOINT = `${STRIPE_CUSTOMERS_ENDPOINT}/${uid}`

  firedux.ref.child(ENDPOINT).on('value', onCurrentCustomer)
}

export const unwatchCurrentCustomer = () => {
  const uid = getState().getIn(['currentUser', 'uid'])

  if (!uid) return

  const ENDPOINT = `${STRIPE_CUSTOMERS_ENDPOINT}/${uid}`

  firedux.ref.child(ENDPOINT).off('value', onCurrentCustomer)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/current_customer.js
 **/